import { global_image_half_screen_hero } from '../../utils/requests/contentstack/contentStackZodSchema';
import type { ImageHalfScreenHeroProps } from './ImageHalfScreenHero';
import { getCloudinaryImageFields } from '../../utils/getCloudinaryItem/getCloudinaryItem';
export const imageHalfScreenHeroSchema = global_image_half_screen_hero.transform<ImageHalfScreenHeroProps>(data => ({
  title: data.title,
  ctaCopy: data.cta_text,
  ctaHref: data.cta_href,
  description: data.description,
  eyebrow: data.eyebrow,
  image: getCloudinaryImageFields({
    alt: data.image.alt,
    cloudinaryField: data.image.src,
    shouldUseV2: true
  }),
  signInUrl: data.sign_in_url,
  variant: data.variant,
  contentOrder: data.content_order ?? 'textFirst'
}));